// Colors
export const BLACK = 'rgba(10, 11, 12, 1)';
export const BLACK_05 = 'rgba(10, 11, 11, 0.05)';
export const BLACK_1 = 'rgba(10, 11, 12, 0.1)';
export const BLACK_2 = 'rgba(10, 11, 11, 0.2)';
export const BLACK_3 = 'rgba(10, 11, 11, 0.3)';
export const BLACK_4 = 'rgba(10, 11, 12, 0.4)';
export const BLACK_5 = 'rgba(10, 11, 11, 0.5)';

export const GRAY_05 = 'rgba(10, 11, 11, 0.05)';
export const GRAY_30 = 'rgba(10, 11, 11, 0.3)';
export const GRAY_60 = 'rgba(10, 11, 11, 0.6)';

export const GREEN = 'rgba(0, 178, 120, 1)';
export const GREEN_1 = 'rgba(0, 178, 120, 0.1)';
export const GREEN_3 = 'rgba(0, 178, 120, 0.3)';

export const PURPLE = 'rgba(103, 117, 226, 1)';
export const PURPLE_2 = 'rgba(103, 117, 226, 0.2)';

export const GREEN_DARK = 'rgba(1, 161, 109, 1)';
export const LIGHT_GREEN_BLUR = 'rgba(203, 239, 226, 0.8)';

export const WHITE = 'rgba(255, 255, 255, 1)';
export const WHITE_7 = 'rgba(255, 255, 255, 0.7)';
export const WHITE_8 = 'rgba(255, 255, 255, 0.8)';

export const RED = 'rgba(224, 54, 0, 1)';
export const RED_10 = 'rgba(224, 54, 0, 0.1)';

export const YELLOW_LIGHT = 'rgba(255, 248, 222, 1)';

export const BEIGE_LIGHT = 'rgba(250, 246, 237, 1)';

export const BLUR_GREY = 'rgba(242, 242, 242, 0.5)';

// Variables
export const CARD_BORDER = '1px solid rgba(10, 11, 12, 0.2)';
export const CARD_BORDER_RADIUS = '24px';
export const CARD_SHADOW = '0px 2px 3px 0px rgba(10, 11, 12, 0.05), 0px 0px 0px 0px rgba(10, 11, 12, 0)';
export const CARD_SHADOW_HOVER = '0px 2px 3px 0px rgba(10, 11, 12, 0.02), 0px 8px 16px 0px rgba(10, 11, 12, 0.1)';

// Media quaries
export const mq = {
  xl: '@media screen and (max-width: 1280px)',
  lg: '@media screen and (max-width: 1120px)',
  md: '@media screen and (max-width: 1024px)',
  sm: '@media screen and (max-width: 768px)',
  xs: '@media screen and (max-width: 480px)',
};
